import React, { useState, useEffect } from "react";
import { Route, Routes,useNavigate } from "react-router-dom";
import { SkewLoader } from "react-spinners"; // Import SkewLoader
import Home from "./Users/Home"
import RegisterDevice from "./Admin/RegisterDevice"
import RegisterUser from "./Admin/RegisterUser";
import Login from "./Users/Login";
import ProtectedRoute from "./TokenAccess"; // Import ProtectedRoute
import NotFoundImage from "./Erros/404Err";
import NavbarMinimal from "./Admin/Dashboard";
import UserProfile from "./Components/ClientProfile";
import AdminProfile  from "./Components/AdminProfile";
import ResetPass from "./Admin/ResetPass";
import Devices from "./Admin/Devices";
import Users from "./Users/UsersDetails";
import DownloadWeatherData from "./Users/DownloadData";
import DeviceDetails from './Users/Devicedetails'
import Recharge from './Admin/Recharge'
import Sites from "./Admin/Sites";
import Forecast from "./Users/Forecast";

function App() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate loading (like fetching data, etc.)
    setTimeout(() => setLoading(false), 2000); // 2 seconds loading time
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const expiryTime = tokenData.exp * 1000; // Convert to milliseconds

      if (expiryTime < Date.now()) {
        localStorage.removeItem('token');
        navigate('/');
      }
    }
  }, );

  return (
    <>
      
      {loading ? (
        // Show spinner while loading
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <SkewLoader color="#2C3930" size={50} />
        </div>
      ) : (
        // Show routes once loading is complete
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/ResetPassword" element={<ResetPass />} />

          {/* Protected Routes for Admin */}
          <Route element={<ProtectedRoute role="admin" />}>
            <Route path="/home" element={<NavbarMinimal />} />
            <Route path="/admin/dashboard" element={<RegisterDevice />} />
            <Route path="/Create-user" element={<RegisterUser />} />
            <Route path="/Admin" element={<AdminProfile />} />
            <Route path="/Devices" element={<Devices />} />
            <Route path="/Users" element={<Users />} />
            <Route path="/Recharge" element={<Recharge />} />
            <Route path="/Maps" element={<Sites />} />
          </Route>

          {/* Protected Route for User */}
          <Route element={<ProtectedRoute role="user" />}>
            <Route path="/user/dashboard" element={<Home />} />
            <Route path="/clients" element={<UserProfile />} />
            <Route path="/data/reports" element={<DownloadWeatherData />} />
            <Route path="/device/:id" element={<DeviceDetails />} />
            <Route path="/Forecast" element={<Forecast/>}/>
          </Route>

          {/* Catch-all Route */}
          <Route path="*" element={<NotFoundImage />} />
        </Routes>
      )}
    </>
  );
}

export default App;
